import React, { useState, useEffect } from 'react';
import { Formik } from "formik";
import RouterPropsWrapper from '../../../../common/RouterPropsWrapper';
import LoadingAnimation from "../../../../common/components/base/LoadingAnimation";
import CampaignFormSimulation from "../CampaignFormSimulation";
import { useChallengeInstance } from '../../../../hooks/useChallengeInstance';
import { useChallenge } from '../../../../hooks/useChallenge';
import { useEvaluateStep } from '../../../../hooks/useEvaluateStep';
import ChallengePanel from '../../ChallengePanel';
import SandboxLayout from "../../../../hoc/SandboxLayout/SandboxLayout";
import { campaignAdsManagerData } from "../../../../utils/data/sandboxes";

const CampaignAdServerStep2 = (props) => {
  const { match, history } = props;
  const challengeId = match.params.id;
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stepTime, setStepTime] = useState(0);
  
  // Fetch challenge instance data
  const { data: challengeInstanceData, isLoading: isLoadingInstance, error: errorInstance } = useChallengeInstance(challengeId);
  
  const challengeType = challengeInstanceData?.challengeInstance?.challengeType;
  
  // Fetch challenge data
  const { data: challengeData, isLoading: isLoadingChallenge, error: errorChallenge } = useChallenge(challengeType);
  
  const evaluateStepMutation = useEvaluateStep();

  // Start step timer
  useEffect(() => {
    const timer = setInterval(() => {
      setStepTime(prevTime => prevTime + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleTab = async (values) => {
    setIsSubmitting(true);
    const action = {
      actionNeeded: 'complete',
      target: JSON.stringify({
        "type": "campaign",
        "fields":
        {
          "name": values.name,
          "advertiser": values.advertiser,
          "scheduleDuration": values.scheduleDuration
        }
      }),
      stepTime: stepTime
    };
    try {
      let res = await evaluateStepMutation.mutateAsync({
        challengeId: challengeId,
        action: action,
        challengeToDo: null
      });
      let value = res.challengeStepEvaluator?.targetLocation || '';
      if (value !== '')
        history.push(value + challengeId);
    } catch (error) {
      console.error('Error evaluating step:', error);
      setIsSubmitting(false);
    }
  };

  if (isLoadingInstance || isLoadingChallenge) return <LoadingAnimation />;
  if (errorInstance) return <div>Error loading challenge instance: {errorInstance.message}</div>;
  if (errorChallenge) return <div>Error loading challenge: {errorChallenge.message}</div>;
  if (!challengeType) return <LoadingAnimation />;

  const challenge = challengeData?.challengeDefinition ? (typeof challengeData.challengeDefinition === 'string' ? JSON.parse(challengeData.challengeDefinition) : challengeData.challengeDefinition) : null;
  if (!challenge) return <div>No Campaigns available</div>;

  const StepCountDownTime = challenge.steps[1].countdownTime;

  return (
    <SandboxLayout name="Campaigns" challengeMode={true} layoutData={campaignAdsManagerData}>
      <div className="wizard-container">
        <div className="col-md-12 col-12 mr-auto ml-auto">
          <div className="card card-wizard active" data-color="rose" id="wizardProfile">
            <div>
              <div>
                <Formik
                  initialValues={{ name: "", advertiser: "", scheduleDuration: "" }}
                >
                  {({ values, handleChange, setFieldValue }) => (
                    <CampaignFormSimulation
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                      handleTab={handleTab}
                      caption="Campaign"
                      id={challengeId}
                      values={values}
                      isSubmitting={isSubmitting}
                    />)}
                </Formik>
                <ChallengePanel time={StepCountDownTime}
                  description={challenge.challengeDescription}
                  coach={challenge.coach}
                  challengeTitle={challenge.challengeTitle}
                  challengeIsValidation={challenge.isValidation}
                  challengeDifficulty={challenge.challengeDifficulty}
                  challengeAverageTime={challenge.averageTime}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SandboxLayout>
  );
};

export default RouterPropsWrapper(CampaignAdServerStep2);

